import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getAuth, onIdTokenChanged } from 'firebase/auth';
import CssBaseline from '@mui/material/CssBaseline';

import { authActions, authSelectors } from './authentication/modules/auth';
import AppRouter from './router/AppRouter';
import theme from './theme';
import { coreActions } from './redux/CoreSlice/core';
import TabIcon from './TabIcon';
import PasskeySetupPrompt from './authentication/components/PasskeySetupPrompt';
import { useSelector } from 'react-redux';

function App() {

    const dispatch = useDispatch();
    const [authChecked, setAuthChecked] = useState(false);
    const promptPasskeySetup = useSelector(authSelectors.promptPasskeySetup);

    // Debug logging to track prompt state changes
    useEffect(() => {
    }, [promptPasskeySetup]);

    const handleClose = () => {
        dispatch(authActions.setPromptPasskeySetup(false));
    }

    useEffect(() => {
        const code = localStorage.getItem('code');
        if(code) dispatch(coreActions.setCode(code));
    }, []);

    useEffect(() => {
        const unsub = onIdTokenChanged(getAuth(), user => {
            if(!user){
                dispatch(authActions.clearAuth());
                dispatch(authActions.setAuthReady(true));
                setAuthChecked(true);
            } else {
                user.getIdTokenResult(true).then(response => {
                    const claims = response?.claims;

                    if(!claims) {
                        dispatch(authActions.clearAuth());
                    }
                    else {
                        dispatch(authActions.setCurrentUser({
                            id: user.uid,
                            email: user.email,
                            tenants: claims.tenants,
                            isFNIAdmin: claims.isFNIAdmin,
                            isValid: claims.isValid,
                            canAccessTenantAdmin: claims.canAccessTenantAdmin,
                        }));
                    }
                    dispatch(authActions.setAuthReady(true));
                    setAuthChecked(true);
                });
            }
        });
        return unsub;
    }, []);

    if (authChecked) {
        return (
            <BrowserRouter basename="/">
                <TabIcon />
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <AppRouter />
                    <PasskeySetupPrompt open={promptPasskeySetup} onClose={handleClose} />
                </ThemeProvider>
            </BrowserRouter>
        );
    }
    return null;
}

export default App;
